import { main } from '../constants';

const initialState = {
  credentials: null,
  credentialsExpirationTime: null,
  loggedInUser: null,
  authorizedModules: null,
  userType: null,
  lastActivity: null,
  loadingMessage: null,
  colorScheme: 'LIGHT',
  windowDimensions: null,
  scrollbarWidth: null,
};

export default (state = initialState, action) => {
  if(action.type === main.LOGOUT) {
    return {
      ...initialState,
      colorScheme: state.colorScheme,
      windowDimensions: state.windowDimensions,
    }
  }
  if(action.type === main.UPDATE_CREDENTIALS) {
    return {
      ...state,
      credentials: action.data.credentials,
      credentialsExpirationTime: action.data.credentialsExpirationTime,
      authorizedModules: action.data.authorizedModules,
      loggedInUser: action.data.loggedInUser !== undefined ? action.data.loggedInUser : state.loggedInUser,
      userType: action.data.userType !== undefined ? action.data.userType : state.userType,
    };
  }
  if(action.type === main.UPDATE_LAST_ACTIVITY) {
    return {
      ...state,
      lastActivity: action.data
    };
  }
  if(action.type === main.UPDATE_LOADING_MESSAGE) {
    return {
      ...state,
      loadingMessage: action.data
    };
  }
  if(action.type === main.UPDATE_COLOR_SCHEME) {
    return {
      ...state,
      colorScheme: action.data
    };
  }
  if(action.type === main.UPDATE_WINDOW_DIMENSIONS) {
    return {
      ...state,
      windowDimensions: action.data
    };
  }
  if(action.type === main.UPDATE_SCROLLBAR_WIDTH) {
    return {
      ...state,
      scrollbarWidth: action.data
    };
  }
  return state
};
